import type { ChatMessage } from "../types";

export const TITLE_CONTEXT_CHARACTERS = 12_000;
export interface TitleMessage { role: "user" | "assistant"; content: string }

const excerpt = (text: string, limit: number) => text.length <= limit ? text
  : `${text.slice(0, Math.floor((limit - 7) / 2))}\n[…]\n${text.slice(-Math.floor((limit - 7) / 2))}`;

/** Sample both ends: instructions often follow a large pasted JSON document. */
export const titleMessages = (messages: ChatMessage[]): TitleMessage[] => {
  const usable = messages.filter(message => message.role === "user" || (message.role === "assistant" && message.status === "complete"));
  const selected = usable.length > 6 ? [...usable.slice(0, 3), ...usable.slice(-3)] : usable;
  return selected.map(message => ({ role: message.role as TitleMessage["role"], content: excerpt([
    excerpt(message.content, 1_600),
    ...(message.attachments?.slice(0, 2).map(file => `${file.name}\n${excerpt(file.text ?? "", 180)}`) ?? []),
  ].join("\n"), 2_000) })).filter(message => message.content.trim());
};

export const cleanConversationTitle = (value: string): string => value
  .replace(/<think>[\s\S]*?<\/think>/gi, "")
  .replace(/^\s*(?:title|标题)\s*[:：]\s*/i, "")
  .replace(/[\u0000-\u001f\u007f]/g, " ")
  .replace(/^\s*["'`“「]+|["'`”」]+\s*$/g, "")
  .replace(/\s+/g, " ").trim().slice(0, 64);

export const isLegacyAutomaticTitle = (title: string, firstPrompt: string): boolean => {
  const prompt = firstPrompt.replace(/\s+/g, " ").trim();
  const previousTitle = prompt.length > 42 ? `${prompt.slice(0, 42)}…` : prompt;
  const withoutBranch = title.replace(/(?: · (?:Branch|分支|Zweig|Rama|Branche|शाखा|Ramificação|분기|فرع|分岐))+$/u, "");
  return Boolean(previousTitle) && withoutBranch === previousTitle;
};
